import Flickity from 'flickity-imagesloaded'

export const settings = {
  selector: '.js-guides-carousel',
  cellSelector: '.js-guides-carousel-slide'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function checks if arrows are disabled and hides them.
 * @param {DOMNode} element
 */
function hideArrowsIfDisabled() {
  const elements = document.querySelectorAll( '.flickity-prev-next-button.previous' )
  Array.from( elements ).forEach(( prevButton ) => {
    const nextButton = prevButton.nextSibling
    if ( prevButton.disabled && nextButton.disabled ) {
      prevButton.style.visibility = 'hidden'
      nextButton.style.visibility = 'hidden'
      prevButton.parentElement.classList.remove( 'js-guides-carousel__has-buttons' )
    } else {
      prevButton.style.visibility = 'visible'
      nextButton.style.visibility = 'visible'
      prevButton.parentElement.classList.add( 'js-guides-carousel__has-buttons' )
    }
  })
}

/**
 * Set carousel element height based on slide height.
 * @param {DOMNode} carouselEl
 */
function setCarouselHeight( carouselEl ) {

  const img = carouselEl.querySelector( '.c-guides-carousel__slide:last-child img' )
  if ( img.complete ) {
    setCarouselHeightHandler( carouselEl )
  } else {
    img.carouselElement = carouselEl
    img.addEventListener( 'load', function( event ) {
      let carouselEl = event.currentTarget.carouselElement
      setCarouselHeightHandler( carouselEl )
    })
  }
}

/**
 * Set carousel element height based on slide height.
 * @param {DOMNode} carouselEl
 */
 function setCarouselHeightHandler( carouselEl ) {

    let tallest = 0
    Array.from( carouselEl.querySelectorAll( '.js-guides-carousel-slide' )).forEach(( element ) => {
      const height = element.querySelector( 'a' ).clientHeight + element.querySelector( '.c-guides-carousel__text' ).clientHeight
      if ( height > tallest ) {
        tallest = height
      }
    })
    carouselEl.style.height = ( tallest ) + 'px'
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const cellElements = Array.from( element.querySelectorAll( settings.cellSelector ))
  if ( cellElements.length > 1 ) {
    initGuidesCarousel( element )
  }
  setTimeout( hideArrowsIfDisabled, 1000 )
}

/**
 *
 * @param {DOMNode} carouselEl
 */
function initGuidesCarousel( carouselEl ) {
  const breakpoint = 720
  // eslint-disable-next-line no-unused-vars
  const carousel = new Flickity( carouselEl, {
    imagesLoaded: true,
    cellSelector: settings.cellSelector,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    autoPlay: true,
    pauseAutoPlayOnHover: true,
    adaptiveHeight: true,
    wrapAround: false,
    groupCells: window.innerWidth < breakpoint ? 1 : 3,
    arrowShape: {
      x0: 35,
      x1: 60, y1: 25,
      x2: 60, y2: 10,
      x3: 60
    }
  })

  setCarouselHeight( carouselEl )

  window.onresize = function() {
    carousel.options.groupCells = window.innerWidth < breakpoint ? 1 : 3
    setTimeout( hideArrowsIfDisabled, 1000 )
    setCarouselHeight( carouselEl )
  }
}
